<template>
    <div >
        <div class="warpper-content">
            <div class="from-content">
                <Password
                    inputId="Current-Password"
                    v-model="CurrentPassword"
                    :inputLbl="lbl.changePassword.CurrentPassword"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :errorInfo="errorInfo[0]"
                    :blockAutoComplete="true">
                </Password>
                <Password
                    inputId="New-Password"
                    v-model="NewPassword"
                    :inputLbl="lbl.changePassword.NewPassword"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :errorInfo="errorInfo[1]"
                    :blockAutoComplete="true"
                    :inputMinLength="8"
                    :inputMaxLength="15"
                    ref="CurrentPassword">
                </Password>
                <Password
                    inputId="Confirm-Password"
                    v-model="ConfirmPassword"
                    :inputLbl="lbl.changePassword.ConfirmPassword"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :errorInfo="errorInfo[2]"
                    :blockAutoComplete="true"
                    ref="error">
                </Password>
            </div>
            <!-- <div class="forget-content">
                <div>{{lbl.changePassword.forget}}</div>
            </div> -->
        </div>
        <div class="bg-btn">
            <button class="save-btn font-semi-bold" @click="clickSave()">
                <div class="text-btn">{{lbl.changePassword.save_btn}}</div>
            </button>
        </div>
        <!-- <div class="forget-content-mobile">{{lbl.changePassword.forget}}</div> -->
    </div>

</template>

<script>
import FormHelper from "@/helper/FormHelper.js";
import LocaleMixin from '@/mixin/LocaleMixin'
import Password from '@/components/Input/Password.vue';
export default {
    name: 'ChangePasswordFrom',
    mixins: [LocaleMixin],
    components: {
        Password,
    },
    data: function() {
        return {
            isFirstSave: true,
            errorInfo: [],
            CurrentPassword: "",
            NewPassword: "",
            ConfirmPassword: "",
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(3);
    },
    methods: {
        clickSave: function() {
            this.isFirstSave = false;
            if (this.validateForm()) {
                if (this.CurrentPassword != this.NewPassword) {
                    if (this.NewPassword == this.ConfirmPassword) {
                        this.validateForm()
                        this.param = {
                            CurrentPassword: this.CurrentPassword,
                            NewPassword: this.NewPassword,
                        };
                        this.$emit('onChangePassword', this.param);
                    } else {
                        this.$refs['error'].validatePassword(this.NewPassword);
                    }
                } else {
                    this.$refs['CurrentPassword'].validateCurrentPassword(this.CurrentPassword);
                }
            }
        },
        validateForm: function() {
            return FormHelper.validate(this.errorInfo);
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '@/style/base/base.scss';

    .warpper-content {
        display: flex;
        width: 100%;
        .from-content {
            width: 100%;
            max-width: 367px;
            margin: 0 auto;
            @include max-mobile {
                max-width: 100%;
            }
        }
        .forget-content {
            width: 100%;
            padding: 40px 0px 0px 10px;
            color: $main-orange-color;
            text-decoration: underline;
            max-width: 162px;
            @include max-mobile {
                display: none;
            }
        }
    }
    .bg-btn{
        display: flex;
        width: 100%;
        max-width: 318px;
        margin: 0 auto;
        @include max-mobile {
            display: flex;
            justify-content: center;
            max-width: 100%;
        }
    }
    .save-btn {
        width: 100%;
        max-width: 330px;
        height: 45px;
        margin-top: 24px;
        margin-bottom: 28px;
        background-color: $main-orange-color;
        padding: 10.5px 0px;
        border: none;
        border-color: $main-orange-color;
        border-radius: 10px;
        outline: none;
        @include max-mobile {
            max-width: 100%;
        }
        .text-btn {
            font-size: 16px;
            font-weight: 600;
            text-align: center;
            color: white;
        }
    }

    .forget-content-mobile {
        display: none;
        @include max-mobile {
            display: block;
            width: 100%;
            text-align: center;
            padding: 20px 0px 0px 0px;
            color: $main-orange-color;
            text-decoration: underline;
        }
    }
</style>
